import axios from "axios";
import Cookies from "js-cookie";

export default axios.create({
    headers: {
        authorization: `Bearer ${Cookies.get("token")}`,
    },
});